var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input-number',{attrs:{"size":"small","precision":2,"placeholder":"请输入数字","controls":false,"min":_vm.info.detectionRangeMin,"max":_vm.info.detectionRangeMax},on:{"blur":_vm.updateValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }